export default "__VITE_ASSET__QNlauMFE__"